import { FC } from 'react';
import { AupScreen, buildAupWebViewUrl } from '@/api/aupApi';
import { PopupPageTemplate } from '@/components/uiParts/Template/PopupPageTemplate/PopupPageTemplate';

/**
 * aup（まもリスCall）連携エントリー
 *
 * PDF「まもリスCALL WebView 連携ガイド(2026-06-30)」準拠。
 * GMO決済(paymentRoutes)と同じ PopupPageTemplate（ルータブルPopup）で開き、
 * その中に まもリスCall のWebViewを iframe 埋め込みで表示する。
 * ログイン済み会員のSanctumトークンを accessToken クエリに付与するのみ（POST認証なし）。
 * 「閉じる」でPopupを閉じれば元画面へ戻れる（アプリ内で完結）。
 */
export const AupEntry: FC<{ screen?: AupScreen }> = ({ screen = 'home' }) => {
  const url = buildAupWebViewUrl(screen);

  return (
    <PopupPageTemplate id="AupEntry" pageName="AupEntry" title="ロードサービス">
      {url ? (
        <iframe
          src={url}
          title="まもリスCall"
          allow="geolocation; camera; microphone; fullscreen"
          style={{
            width: '100%',
            height: 'calc(100vh - 120px)',
            border: 'none',
          }}
        />
      ) : (
        <p className="text-align-center">
          ロードサービスに接続できませんでした。時間をおいて再度お試しください。
        </p>
      )}
    </PopupPageTemplate>
  );
};
